




















import Vue from 'vue';
import Component from 'vue-class-component';
import IdentityButtons from './identity/IdentityButtons.vue';

@Component({
    components: {
        IdentityButtons,
    },
})
export default class WelcomeCard extends Vue {

}
